<template>
  <div class="flex h-full row">
    <div class="flex-1">
      <slot />
    </div>
    <div class="flex items-end">
      <slot name="image" />
    </div>
  </div>
</template>

<script lang="ts">
export default defineComponent({
  name: 'SubBannerLayout',
});
</script>
